import ServerUrl from './Constants/ServerUrl';
import Version from './Constants/Version';

let Title = 'Purch Publisher Services';

if (ServerUrl.indexOf('qa') > -1) {
  Title += ' - QA environment';
  if (Version !== undefined) {
    Title += ' (v' + Version + ')';
  }
} else if (ServerUrl.indexOf('localhost') > -1 || ServerUrl.indexOf('amc:') > -1) {
  Title += ' - Dev environment';
}

export default Title;



// WEBPACK FOOTER //
// ./src/views/Framework/Title.tsx